import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Grid,
  Paper,
  Typography,
  Box,
  Card,
  CardContent,
  CardActions,
  Button
} from '@mui/material';
import {
  People,
  Pets,
  LocalHospital,
  Medication,
  AttachMoney,
  Inventory  // ← NOUVEL IMPORT pour l'icône Stock
} from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';

const DashboardCard = ({ title, icon, color, onClick }) => (
  <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
    <CardContent sx={{ flexGrow: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Box
          sx={{
            backgroundColor: color,
            borderRadius: '70%',
            p: 1,
            display: 'flex',
            mr: 2
          }}
        >
          {icon}
        </Box>
        <Typography variant="h6">{title}</Typography>
      </Box>
    </CardContent>
    <CardActions>
      <Button size="small" onClick={onClick}>
        Ouvrir
      </Button>
    </CardActions>
  </Card>
);

const Dashboard = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  // Modules de base
  const baseModules = [
    {
      title: 'Clients',
      icon: <People sx={{ color: 'white' }} />,
      color: '#1976d2',
      path: '/clients'
    },
    {
      title: 'Animaux',
      icon: <Pets sx={{ color: 'white' }} />,
      color: '#2e7d32',
      path: '/animaux'
    },
    {
      title: 'Consultations',
      icon: <LocalHospital sx={{ color: 'white' }} />,
      color: '#d32f2f',
      path: '/consultations'
    },
    {
      title: 'Médicaments',
      icon: <Medication sx={{ color: 'white' }} />,
      color: '#ed6c02',
      path: '/medicaments'
    },
    {
      title: 'Dettes & Paiements',
      icon: <AttachMoney sx={{ color: 'white' }} />,
      color: '#9c27b0',
      path: '/dettes'
    }
  ];

  // ====== NOUVEAU MODULE STOCK ======
  // Module Stock selon le rôle
  const stockModule = () => {
    if (user?.role === 'Technicien') {
      return {
        title: 'Mon Stock',
        icon: <Inventory sx={{ color: 'white' }} />,
        color: '#00897b',
        path: '/stock/technicien'
      };
    } else if (user?.role === 'Vétérinaire' || user?.role === 'Admin') {
      return {
        title: 'Gestion de Stock',
        icon: <Inventory sx={{ color: 'white' }} />,
        color: '#00897b',
        path: '/stock/veterinaire'
      };
    } else if (user?.role === 'Secrétaire') {
      return {
        title: 'Gestion de Stock',
        icon: <Inventory sx={{ color: 'white' }} />,
        color: '#00897b',
        path: '/stock/principal'
      };
    }
    return null;
  };

  // Ajouter le module stock s'il existe pour ce rôle
  const modules = stockModule() 
    ? [...baseModules, stockModule()] 
    : baseModules;
  // ==================================

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Paper sx={{ p: 3, background: 'linear-gradient(to bottom, #f1f7f7ff, #27777cff)', mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          Bienvenue, {user?.prenom} {user?.nom} 
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Cabinet : {user?.cabinet}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Rôle : {user?.role}
        </Typography>
      </Paper>

      <Grid container spacing={3}>
        {modules.map((module) => (
          <Grid item xs={12} sm={6} md={4} key={module.title}>
            <DashboardCard
              title={module.title}
              icon={module.icon}
              color={module.color}
              onClick={() => navigate(module.path)}
            />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Dashboard;